'use client';

import { styled } from '../../styles';

export const DataDetailsMobileDrawerContainer = styled('div')(({ theme }) => ({
  width: '100%',
  paddingBottom: theme.spacing(12),
}));

export const DataDetailsMobileDrawerRows = styled('div')(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(0, 4),
}));

export const DataDetailsMobileDrawerRow = styled('div')(({ theme }) => ({
  width: '100%',
  height: 54,
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const DataDetailsMobileDrawerRowCell = styled('div')(({ theme }) => ({
  width: '50%',
  textAlign: 'start',
}));

export const DataDetailsMobileDrawerFooterContainer = styled('div')(
  ({ theme }) => ({
    width: '100%',
    padding: theme.spacing(6, 5, 0, 5),
  }),
);
